import React from 'react';
import { Form } from 'antd';
import moment from 'moment';
import PropTypes from 'prop-types';

import FormLabel from 'components/FormLabel/FormLabel';

import { FullWidthDatePicker } from './FormDatePicker.styles';

const FormItem = Form.Item;

const disabledDate = current => {
  return current && current > moment().endOf('day');
};

const FormDatePicker = ({ disabled, extraProps, label, name, placeholder, onFocus, requiredErrorMessage, isDob }) => {
  const generatePropsForRules = () => {
    const rules = [];
    if (requiredErrorMessage && typeof requiredErrorMessage === 'string') {
      rules.push({
        required: true,
        message: requiredErrorMessage
      });
    }
    return rules;
  };

  return (
    <>
      <FormLabel>{label}</FormLabel>
      <FormItem rules={generatePropsForRules()} name={name} onFocus={() => onFocus(name)}>
        <FullWidthDatePicker disabled={disabled} placeholder={placeholder} {...extraProps} disabledDate={isDob ? disabledDate : undefined} />
      </FormItem>
    </>
  );
};

FormDatePicker.propTypes = {
  extraProps: PropTypes.object,
  onFocus: PropTypes.func,
  isDob: PropTypes.bool
};

FormDatePicker.defaultProps = {
  extraProps: {},
  onFocus: () => {},
  isDob: false
};

export default FormDatePicker;
